import React, { useMemo, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const PdfDisplay = ({ pdfFile }) => {
  const pdfUrl = useMemo(() => {
    if (!pdfFile) return null;
    try {
      const sanitizedFile = new File([pdfFile], pdfFile.name.replace(/[#&<>|\?:*]/g, '_'), {
        type: pdfFile.type
      });
      return URL.createObjectURL(sanitizedFile);
    } catch (error) {
      console.error('Error creating PDF URL:', error);
      return null;
    }
  }, [pdfFile]);

  useEffect(() => {
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [pdfUrl]);

  if (!pdfFile) {
    return (
      <Box sx={{ 
        height: '100%', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        bgcolor: 'grey.100',
        borderRadius: 1
      }}>
        <Typography color="text.secondary">
          No PDF file selected
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <iframe
        src={pdfUrl}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          borderRadius: '4px'
        }}
        title="PDF Viewer"
      />
    </Box>
  );
};

export default React.memo(PdfDisplay); 